import * as e from "vue";
var s;
let n = Symbol("headlessui.useid"), o = 0;
const r = (s = e.useId) != null ? s : function() {
  return e.inject(n, () => `${++o}`)();
};
export {
  r as useId
};
